import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import SessionRollArea from '../../../components/sessionRoll'
import './style.scss'
const SessionRollAreaPage = () => {

    return (
        <Fragment>
            
           <SessionRollArea
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default SessionRollAreaPage
/* SessionRollArea */